module.exports = __webpack_public_path__ + "static/img/wenzhou.012f719.png";


//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/mapPicture/zhejiang/wenzhou.png
// module id = +UCx
// module chunks = 6